<template lang="html">
<transition name="bg">
  <div class="bg-box" v-if="show.other !== ''">
    <div class="main-bg" @click="display">
    </div>
    <comp-account></comp-account>
    <comp-workspace></comp-workspace>
  </div>
</transition>
</template>

<script>
import { mapGetters } from 'vuex'
import CompAccount from '@/components/other/account.vue'
import CompWorkspace from '@/components/other/workspace.vue'
export default {
  computed: {
    ...mapGetters({
      show: 'show'
    })
  },
  components: {
    CompAccount,
    CompWorkspace,
  },
  mounted () {
    if (sessionStorage.getItem('orderNo')) {
      this.$api.getOrder(sessionStorage.getItem('orderNo'), response => {
        var data = {
          type: 'order',
          orderNo: response.order_no
        }
        this.$store.dispatch('showOther', data)
        sessionStorage.removeItem('orderNo')
      })
    }
  },
  methods: {
    display () {
      if (this.show.other === 'download') {
        this.$store.dispatch('showOther', '')
      }
      if (this.show.left) {
        this.$store.dispatch('showLeft', false)
      }
    }
  }
}
</script>

<style scoped lang="css">
.bg-box {
  z-index: 1000;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: fixed;
  background-color: transparent;
}
.main-bg {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #000;
  opacity: 0.2;
}
.box {
  z-index: 9999;
  opacity: 1;
  position: absolute;
  height: 700px;
  width: 600px;
  left: 50%;
  margin-left: -300px;
  background-color: #fff;
  margin-top: 80px;
  -webkit-box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.35);
  box-shadow: 1px 1px 8px rgba(0, 0, 0, 0.35);
  border-radius: 4px;
}
.bg-leave-active {
  transition: opacity .24s
}
.bg-leave-to {
  opacity: 0
}
</style>
